import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye } from "@fortawesome/free-solid-svg-icons"
import { fetchFacturation } from "../../store/actions/facturationActions"
import Loader from "../basics/Loader"
import { COLORS } from "../../utilities/Constants"
import { generalStyles as gs } from "../styles/styles"
import { tableStyles } from "../styles/tableStyles"

// 3 onglets, un par type de fiche. Chaque onglet liste les transactions « Facture »
// non datées scopées par type (cf. FacturationView). Le dépannage est volontairement
// vide pour l'instant (module pas prêt).
const TABS = [
	{ key: "depannage", label: "Dépannage" },
	{ key: "atelier", label: "Atelier" },
	{ key: "location", label: "Location" },
]

const FactureRow = ({ row, index, onOpen }) => {
	const [hover, setHover] = useState(false)
	const bg = hover ? tableStyles.rowHover : tableStyles.rowBg(index)
	const veh = row.vehicule || {}
	return (
		<tr
			onDoubleClick={() => onOpen(row)}
			onMouseEnter={() => setHover(true)}
			onMouseLeave={() => setHover(false)}
			style={{
				backgroundColor: bg,
				cursor: "pointer",
				transition: "background-color 0.12s",
			}}
		>
			<td style={tableStyles.td}>{row.date_travaux || "—"}</td>
			<td style={tableStyles.td}>
				<strong style={{ fontWeight: 600 }}>{row.entite || "—"}</strong>
			</td>
			<td style={tableStyles.td}>{row.paye_par_label || "—"}</td>
			<td style={tableStyles.td}>{veh.plaques || "—"}</td>
			<td style={tableStyles.td}>{veh.marque || "—"}</td>
			<td style={{ ...tableStyles.td, color: COLORS.textMuted }}>
				{veh.modele || "—"}
			</td>
			<td style={tableStyles.tdRight}>
				<button
					style={gs.iconBtn(COLORS.text)}
					onClick={(e) => {
						e.stopPropagation()
						onOpen(row)
					}}
					title="Ouvrir la fiche"
				>
					<FontAwesomeIcon icon={faEye} />
				</button>
			</td>
		</tr>
	)
}

const Facturation = () => {
	const dispatch = useDispatch()
	const history = useHistory()
	const [tab, setTab] = useState("atelier")
	const { ateliers, locations, depannages, fetchFacturation: fetchState } =
		useSelector((state) => state.facturationInfo)

	// (Re)charge la tranche du type actif à chaque changement d'onglet.
	useEffect(() => {
		dispatch(fetchFacturation({ type: tab }))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tab])

	// Lignes + ouverture de fiche selon l'onglet courant.
	const rows =
		tab === "atelier"
			? ateliers
			: tab === "location"
				? locations
				: depannages
	const openFiche = (row) => {
		if (tab === "atelier")
			history.push(`/atelier/fiche/${row.fiche_id}`, {
				from: "facturation",
			})
		else if (tab === "location")
			history.push(`/location/fiche/${row.fiche_id}`, {
				from: "facturation",
			})
	}

	const loading = fetchState.loading

	return (
		<div style={gs.page}>
			<div style={{ ...gs.title, marginBottom: 24 }}>Facturation</div>

			{/* Sélecteur principal : segmented control (style /configuration). */}
			<div style={gs.segmented}>
				{TABS.map((t) => (
					<button
						key={t.key}
						type="button"
						style={gs.segment(tab === t.key)}
						onClick={() => setTab(t.key)}
					>
						{t.label}
					</button>
				))}
			</div>

			<div style={tableStyles.container}>
				{loading ? (
					<Loader variant="ring" message="Chargement…" />
				) : tab === "depannage" ? (
					<div style={styles.empty}>
						Module dépannage pas encore disponible.
					</div>
				) : rows.length === 0 ? (
					<div style={styles.empty}>Aucune fiche à facturer.</div>
				) : (
					<table style={tableStyles.table}>
						<thead>
							<tr>
								<th style={tableStyles.th}>Date des travaux</th>
								<th style={tableStyles.th}>Client</th>
								<th style={tableStyles.th}>Facturer à</th>
								<th style={tableStyles.th}>Plaques</th>
								<th style={tableStyles.th}>Marque</th>
								<th style={tableStyles.th}>Modèle</th>
								<th style={tableStyles.thRight}>Actions</th>
							</tr>
						</thead>
						<tbody>
							{rows.map((row, i) => (
								<FactureRow
									key={`fact_${tab}_${i}`}
									row={row}
									index={i}
									onOpen={openFiche}
								/>
							))}
						</tbody>
					</table>
				)}
			</div>
		</div>
	)
}

const styles = {
	empty: {
		...tableStyles.empty,
		padding: "48px 16px",
		color: COLORS.textLight,
		fontSize: 14,
	},
}

export default Facturation
